module.exports = __webpack_public_path__ + "static/media/right-chevron.868f22d4.svg";